<template>
  <div>
    <div v-if="!isRecording && !hasResult">
      <b-button variant="outline-primary" @click="startRecording">
        <i class="ti-microphone pr-1"></i> {{ $t('MdTextSpeech.recordCommand') }}
      </b-button>
    </div>

    <div v-if="isRecording" class="mt-2">
      <div v-if="micError" class="p-3 border rounded bg-danger-subtle text-danger-emphasis">
        <div>
          <strong>{{ $t('MdTextSpeech.micError') }}</strong><br>
          {{ micErrorMessage }}
        </div>
        <b-button variant="primary" class="mt-2 ms-2" size="sm" @click="reRecord">
          <i class="ti-reload pr-1"></i> {{ $t('MdTextSpeech.recordAgain') }}
        </b-button>
      </div>
      <div v-else class="p-2 border rounded bg-white text-muted fst-italic" style="min-height: 36px;">
        <span v-if="interimTranscript">{{ interimTranscript }}</span>
        <span v-else class="d-flex align-items-center gap-2">
          <span class="spinner-grow spinner-grow-sm text-danger" role="status"/>
          {{ $t('MdTextSpeech.listening') }}
        </span>
      </div>
    </div>

    <div v-if="hasResult && !isRecording" class="mt-3">
      <b-form-group label="Command phrase (edit if needed)">
        <b-form-input v-model="editableTrigger" @input="emitTrigger" />
      </b-form-group>
      <b-button variant="primary" class="mt-2 ms-2" size="sm" @click="reRecord">
        <i class="ti-reload pr-1"></i> {{ $t('MdTextSpeech.recordAgain') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus.js'

export default {
  name: 'MdCommandSpeechCapture',
  props: {
    initialTrigger: { type: String, default: '' }
  },
  data() {
    return {
      controlId: `commandTrigger-${this._uid}`, // unique per instance, avoids collision with other EventBus consumers
      isRecording: false,
      hasResult: !!this.initialTrigger,
      interimTranscript: '',
      editableTrigger: this.initialTrigger,
    };
  },
  computed: {
    speechEngine() {
      return this.$root.$refs.MdAIDictationSpeech;
    },
    micError() {
      return this.speechEngine ? this.speechEngine.micError : false;
    },
    micErrorMessage() {
      return this.speechEngine ? this.speechEngine.micErrorMessage : '';
    }
  },
  beforeDestroy() {
    EventBus.$off('setupInterimTranscript');
    EventBus.$off('finishCommand');
  },
  methods: {
    startRecording() {
      if (!this.speechEngine) {
        console.error('MdAIDictationSpeech instance not found on $root.$refs');
        return;
      }
      this.hasResult = false;
      this.interimTranscript = '';
      this.isRecording = true;
      EventBus.$emit('speechBarLabel', this.$t('MdTextSpeech.stopairecording'));
      this.$root.$refs.MdAIDictationSpeech.toggleSpeechBar();
      this.$root.$refs.MdAIDictationSpeech.RecordCommand();
    },
    reRecord() {
      this.hasResult = false;
      this.editableTrigger = '';
      this.startRecording();
    },
    onInterim(payload) {
      this.interimTranscript = payload;
    },
    onFinal(payload) {
      this.editableTrigger = payload;
      this.interimTranscript = '';
      this.hasResult = true;
      this.emitTrigger();
    },
    emitTrigger() {
      this.$emit('update:trigger', this.editableTrigger);
    }
  },
  mounted() {
    EventBus.$on('setupInterimTranscript', (payload) => {
      this.onInterim(payload);
    });
    EventBus.$on('finishCommand', (payload) => {
      this.onFinal(payload);
      this.isRecording = false;
    });
  }
};
</script>